import styled from "@emotion/styled";
export const DockWrapper = styled.div`
    position: sticky;
    border-radius: 12px;
    /* Move the dock 16px + safe area above the bottom of the parent */
    bottom: calc(env(safe-area-inset-bottom, 0px) + 16px);
    bottom: calc(
        constant(safe-area-inset-bottom, 0px) + 16px
    ); /* iOS < 11.2 fallback */

    /* 16px spacing from left and right of the parent */
    margin: 0 16px;
    width: auto;

    background: #23252a;
    border-top: 1px solid #2b2d33;
    box-shadow: 0px -2px 8px 0px #00000040;

    /* Internal padding of the dock itself */
    padding: 12px 16px;

    display: flex;
    justify-content: center;
    z-index: 10;
    box-sizing: border-box;
`;

export const DockContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;
`;

export const DockItem = styled.button`
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    height: 60px;
    width: 60px;
    cursor: pointer;

    &:focus-visible {
        outline: 2px solid #b7bdcb;
        outline-offset: 2px;
    }
`;

export const DockIcon = styled.img`
    display: block;
`;

export const DockLabel = styled.span`
    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 11px;
    line-height: 120%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: #b7bdcb;
`;

export const DoneButton = styled.button`
    color: white;
    font-size: 16px;
    font-family: Inter;
    font-weight: 600;
    word-wrap: break-word;
    height: 44px;
    padding: 8px;
    background: #5e84ed;
    border-radius: 12px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    display: inline-flex;
    width: 100%;
    border: none;
    cursor: pointer;
    outline: none;
`;
